import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { shouldSkipInactivityForRequest } from 'src/app/core/utils/auth-url.util';
import { InactivityService } from 'src/app/services/inactivity/inactivity.service';

export const inactivityInterceptor: HttpInterceptorFn = (req, next) => {
  if (!shouldSkipInactivityForRequest(req.url)) {
    inject(InactivityService).onApiActivity();
  }

  return next(req);
};
